import { render, staticRenderFns } from "./crudInstancesCategories.vue?vue&type=template&id=4f913ad1"
import script from "./crudInstancesCategories.vue?vue&type=script&lang=js"
export * from "./crudInstancesCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports